import React from "react";
import A4PageFrame from "./A4PageFrame";
import { fmtNum, fmtPct } from "./formatters";

// "Résultats par module" — SINGLE landscape page, TABLE ONLY.
// Pass #3: the client asked to delete the graphs here (e.g. Etang B has too many
// modules for a readable chart). Column list: Numéro / Module / Surface m² /
// <year> HT / CHF/m2 / <year> TTC / <prior year> HT / Diff. HT / Diff.% / Part %.
const ResultsPerModule = ({
  data,
  building,
  periodLabel,
  periodYears,
  compareEnabled,
  whiteLabelling,
  logoUrl,
  basePageNumber = 1,
  grandTotalPages = 1,
}) => {
  const modules = data?.modules || [];
  const totals = data?.totals || {};
  const currentYear = periodYears?.current ?? "";
  const priorYear = periodYears?.prior ?? "";

  return (
    <A4PageFrame
      building={building}
      periodLabel={periodLabel}
      sectionTitle="Résultats par module"
      whiteLabelling={whiteLabelling}
      logoUrl={logoUrl}
      pageNumber={basePageNumber}
      totalPages={grandTotalPages}
      landscape
      resultsPage
    >
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 4 }}>
        <thead>
          <tr style={{ borderBottom: "1px solid #00033F" }}>
            <th style={th}>Numéro</th>
            <th style={th}>Module</th>
            <th style={thNum}>Surface m²</th>
            <th style={thNum}>{currentYear} HT</th>
            <th style={thNum}>CHF/m2</th>
            <th style={thNum}>{currentYear} TTC</th>
            {compareEnabled && <th style={thNum}>{priorYear} HT</th>}
            {compareEnabled && <th style={thNum}>Diff. HT</th>}
            {compareEnabled && <th style={thNum}>Diff. %</th>}
            <th style={thNum}>Part %</th>
          </tr>
        </thead>
        <tbody>
          {modules.map((m) => (
            <tr key={m.numero}>
              <td style={td}>{m.numero}</td>
              <td style={td}>{m.module || ""}</td>
              <td style={tdNum}>{fmtNum(m.surface_m2)}</td>
              <td style={tdNum}>{fmtNum(m.main_ht)}</td>
              <td style={tdNum}>{fmtNum(m.chf_m2)}</td>
              <td style={tdNum}>{fmtNum(m.main_ttc)}</td>
              {compareEnabled && <td style={tdNum}>{fmtNum(m.compare_ht)}</td>}
              {compareEnabled && <td style={tdNum}>{fmtNum(m.diff)}</td>}
              {compareEnabled && <td style={tdNum}>{fmtPct(m.diff_pct)}</td>}
              <td style={tdNum}>{fmtPct(m.part_pct)}</td>
            </tr>
          ))}
          <tr style={{ borderTop: "1px solid #00033F", fontWeight: 700 }}>
            <td style={td} />
            <td style={td}>Total</td>
            <td style={tdNum}>{fmtNum(totals.surface_m2)}</td>
            <td style={tdNum}>{fmtNum(totals.main_ht)}</td>
            <td style={tdNum} />
            <td style={tdNum}>{fmtNum(totals.main_ttc)}</td>
            {compareEnabled && <td style={tdNum}>{fmtNum(totals.compare_ht)}</td>}
            {compareEnabled && <td style={tdNum} />}
            {compareEnabled && <td style={tdNum} />}
            <td style={tdNum} />
          </tr>
        </tbody>
      </table>
    </A4PageFrame>
  );
};

const th = { padding: "4px 6px", fontWeight: 600, textAlign: "left", fontSize: 11 };
const thNum = { ...th, textAlign: "right" };
const td = { padding: "5px 6px", fontSize: 10, lineHeight: "14px", borderBottom: "1px solid rgba(0,3,63,0.05)" };
const tdNum = { ...td, textAlign: "right", fontVariantNumeric: "tabular-nums" };

export default ResultsPerModule;
